import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import './Proximamente.scss';
import { useTranslation } from 'react-i18next';

const ComingSoon = () => {
  const { t } = useTranslation();

  return (
    <div className='coming_soon_container'>
      <div className='coming_soon_content'>
        
        {/* LOGO */}
        <AnimationOnScroll 
          animateIn="animate__fadeInDown" 
          duration={1.5} 
          animateOnce={true}
        >
          <div className='coming_soon_logo'>
            <img src="/assets/logo-P-COPAL.png" alt="Logo" />
          </div>
        </AnimationOnScroll>

        {/* TEXTO */}
        <AnimationOnScroll 
          animateIn="animate__fadeInUp" 
          duration={1.5} 
          delay={500}
          animateOnce={true}
        >
          <div className='coming_soon_text'>
            <h1>{t('coming_soon.title')}</h1>
            <hr />
            <p>{t('coming_soon.subtitle')}</p>
          </div>
        </AnimationOnScroll>

      </div>
    </div>
  );
};

export default ComingSoon;